$(document).ready(function () {
  var left_svg = '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" style="display: block;"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.006 1.61539L4.6214 8H19.2072V10H4.6214L11.006 16.3846L9.5918 17.7988L0.792969 9L9.5918 0.201172L11.006 1.61539Z" fill="#232323"/></svg></button>';
   var right_svg = '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button" style="display: block;"><svg  xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.792969 8H15.3788L8.99414 1.61538L10.4084 0.201172L19.2072 9L10.4084 17.7988L8.99414 16.3846L15.3788 10H0.792969V8Z" fill="#232323"></svg></button>';
  $(".quote-carousel").slick({
    centerMode: false,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 2,
    arrows: true,
    prevArrow:left_svg,
    nextArrow:right_svg,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          centerMode: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          dots: false,
          centerMode: false,
          slidesToShow: 1,
        },
      },
    ],
  });

 $('#status').show();
 $('body').css({'overflow':'hidden'});
  // setTimeout(function(){
  //   $('#preloader').fadeOut('slow');
  //   $('body').css({'overflow':'visible'});
  // },3000);


  /* Sms Popup Show */
   
 /* On page load add loader */
  $(window).on('load', function() { // makes sure the whole site is loaded 
    $('#preloader').delay(6000).fadeOut('slow'); // will fade out the white DIV that covers the website. 
    $('body').delay(1000).css({'overflow':'visible'});
    $('#preloader').fadeOut('slow', function(){
            // $('#MainContent').fadeIn('slow');
        });
    
  });

   $(document).on('click','.atc-btn',function(e){
        e.preventDefault();
        var msg_show= $(this).parents(".variant-wrapper-content-inner");
       var msg_shows= $(this).parents(".product-content-detail");
     console.log(msg_shows)
          var parent = $(this).closest('form');
          var formData = parent.serialize();
          var id = $(parent).find("[name='id']").val(),
              qty = 1;
     console.log(id,'id');
          $.ajax({
            type:"post",
            dataType: "json",
            url: '/cart/add.js',
            data:{id:id, quantity:qty},
            async:false,
            success: function(data)
            {
              var Variant_data = data;
               jQuery.getJSON('/cart.js', function(cart){ 
                 msg_show.find(".cart-msg").css('display','block');    
                 if(msg_shows){
                   msg_shows.find(".cart-msg").css('display','block');    
                 }
                 $(".cart-count-bubble").removeClass("hidden");
                 $(".cart-count-bubble .cart-counts").text(cart.item_count);
                  setTimeout(function(){
                    msg_show.find(".cart-msg").css('display','none');  
                     if(msg_shows){
                   msg_shows.find(".cart-msg").css('display','none');    
                 }
                    },1000);
           });
            }
          });
        });


  /* Video Lightbox */
  /* Video popup */
$(".testimonial-inner-data").on("click", ".quote-inner-content", function (e) {
  var videoSrc = $(this).data('video');
 if (videoSrc) {
   $('#video-source').attr('src', videoSrc);
    $('#video-player')[0].load();
    $('#video-lightbox').fadeIn();
       $('#video-player').get(0).play();
      e.stopPropagation();
  }
});

/* footer link*/
  $(".footer-linklist .shipping-policy a").on("click",function(e) {
    e.preventDefault();
    $(".policy-popup").addClass("active");
    $("body").addClass("show-popup");
     e.stopPropagation();
  });

   /* Cross video popup*/
   // Close the lightbox when the close button is clicked
    $('.close-button').on('click', function() {
        $('#video-lightbox').fadeOut();
        $('#video-player').get(0).pause();
          $('#video-lightbox').removeClass("lighbox-video");

    });

    // Close the lightbox when the user clicks outside of it
    $("body").on('click', function(event) {
        $('#video-lightbox').fadeOut();
        $('#video-player').get(0).pause();
      $(".policy-popup").removeClass("active");
    $("body").removeClass("show-popup");
      $("body").removeClass("show-email");  
      $(".email-popup-form").removeClass("active");
      $(".sms-popup-form").hide();
    });

  /* Close btn click */
  
  $('.popup-close-icons').on('click', function() {
    $(".policy-popup").removeClass("active");
    $(".email-popup-form").removeClass("active");
    $("body").removeClass("show-popup");
     $("body").removeClass("show-email"); 
    });
  
   $(".popup-inner-content").on("click", function (event) {
    if (!$(event.target).hasClass("popup-close-icons")) {
      event.stopPropagation();
    }
  });
  $(".form-outer-container").on("click", function (event) {
    if (!$(event.target).hasClass("popup-close-icons")) {
      event.stopPropagation();
    }
  });

  /* email Inner popup */
  $(".sms-popup-form .inner-popup-form").on("click", function (event) {
    if (!$(event.target).hasClass("popup-close-icons")) {
      event.stopPropagation();
    }
  });

  /*  navigation  link  js*/
  $(".top-navigation-links .links-become-a-retailer a").on('click', function(e) {
     e.preventDefault();
    $(".email-popup-form").addClass("active");
     $("body").addClass("show-email");
         e.stopPropagation();
    });

  /* custom scroll item */
  $(".custom-scroll-outer .inner-repeater-blocks a").on('click', function(e) {
     e.preventDefault();
    $(".email-popup-form").addClass("active");
     $("body").addClass("show-email");
         e.stopPropagation();
    });

  /* Set cookie js */
   $(".popup-header").on("click", ".popup-close-icon", function () {
    $(".sms-popup-form").hide();
    $(".popup-form-outer").removeClass("sms-popup");

    // Get the current time
    var currentTime = new Date().getTime();

    // Set the expiration time to 10 years from the current time
    var expirationTime = currentTime + 10 * 365 * 24 * 60 * 60 * 1000; // Adding milliseconds

    // Create a new Date object with the expiration time
    var expirationDate = new Date(expirationTime);

    // Set the cookie with the correct expiration date
    $.cookie("sms_popup", "1", { expires: expirationDate });
  });

  
  /* Cookie for Sms Popup Form */
  if ($.cookie("sms_popup")) {
    $(".sms-popup-form").hide();
    $(".sms-popup-form").removeClass("sms-popup");
  } else {
     setTimeout(function(){
      $(".sms-popup-form").show();
     $(".sms-popup-form").addClass("sms-popup");
   
  },15000);
    
   
  }


  /* Radio change value js */
  $('.propduct-variants-detail input').on('change', function() {
    var closest_div =$(this).closest(".product-content-detail");
    console.log(closest_div)
  var _selectedOption =$('input[name=id]:checked', '.propduct-variants-detail').val();
    closest_div.find(".hidden-vid").val(_selectedOption);
});
  
});
document.addEventListener("DOMContentLoaded", function () {
  let marqueeElements = document.querySelectorAll(".marquee-wrapper");
  Array.from(marqueeElements).forEach((element) => {
    let scrollingSpeed = parseInt(
      element.getAttribute("data-marquee-speed") || 25
    );
    const contentWidth = element.clientWidth,
      node = element.querySelector(".scroll-items"),
      nodeWidth = node.clientWidth;
    // windowWidth = window.innerWidth;
    let slowFactor = 1 + (Math.max(1600, contentWidth) - 375) / (1600 - 375);
    let speed =
      ((scrollingSpeed * slowFactor * nodeWidth) / contentWidth).toFixed(3) *
      element.querySelectorAll(".scroll-items").length;
    element.parentElement.style.setProperty("--animation-speed", `${speed}s`);
  });
});
